import React from 'react';
import Sidebar from './Sidebar';
import './Layout.css';
import Footer from '../tmlComponents/Footer/Footer';
// import logo from '../images/tata_motors_logo.png'
// import Esakha from '../images/esakha.svg'
// import Support from "../images/support.svg"

const Layout = ({ children }) => {
    return (
        <>
            <Sidebar>
                {children}
            </Sidebar>
            <Footer className="footer" />
            {/* <div className="content-wrapper">
                <div className="content">
                    {children}
                </div>
                <Footer className="footer" />
            </div> */}

            {/* <Header
                images={{ logo, Esakha, Support }}
                // config={config}
                // addSupport={isVendor}
                // envType={ENV_TYPES}
                other={{ alt: 'Tata Motors' }}
            // logoutUser={true}
            // user={user}
            // supportUrl={url}
            />
         */}
        </>
    );
};

export default Layout;



